export default "__VITE_ASSET__C$RWufmg__"